
  import React, { useEffect, useState } from 'react';
  import { useParams } from 'react-router-dom';
  import { useMobileOrientation } from 'react-device-detect';
  import { Container, Row, Col } from 'react-bootstrap';
  import { useDispatch, useSelector } from 'react-redux';
  import { setRounds, setSelectedRound,setbackgroundColor,setlogo,setfontColor, setTeamNames,
    setTeam1bgColor,
    setTeam2bgColor,
    setButtonColor,setbackgroundImg } from '../../Redux/action';
  import 'bootstrap/dist/css/bootstrap.min.css';
  import BasicHeader from '../../Header/BasicHeader';
  import '../../style/HangmanBasic.css';
  import 'animate.css';
  import firebase from '../../firebase';
  import landscapeIcon from '../../image/landscape-icon.webp';
  import templogo from "../../image/check_1.png";


  
  const HangManBasic = ({ onNavigate,audio, musicData, canPlay   }) => {
    const dispatch = useDispatch();
    const { id } = useParams(); 
    const { orientation } = useMobileOrientation();
    const code = localStorage.getItem('code');
    const rounds = useSelector((state) => state.round.rounds);
    const backgroundColor = useSelector(state => state.backgroundColor.backgroundColor);
    const fontColor = useSelector(state => state.fontColor.fontColor);
    // CONSOLE.log(fontColor,"fontColor");
    const teamNames = useSelector(state => state.gameSettings.teamNames);
    const team1bgColor = useSelector(state => state.gameSettings.team1bgColor);
    const team2bgColor = useSelector(state => state.gameSettings.team2bgColor);
    const buttonColor = useSelector(state => state.gameSettings.buttonColor);
    const backgroundImg = useSelector(state => state.backgroundImg.backgroundImg);
    const logo = useSelector(state => state.logo.logo);
   const localization = useSelector((state) => state.localization.localization);
    const [teamScores, setTeamScores] = useState({ team1: 0, team2: 0 });
    const [playedRounds, setPlayedRounds] = useState([]);
    const [teamScoreData, setTeamScoreData] = useState([]); // Declare state for teamScoreData
    const mobile = useSelector(state => state.mobile.isMobile); // Correctly access isMobile
    console.log(mobile,"mobile");
    const backgroundStyle = backgroundImg
    ? {
        backgroundImage: `url(${backgroundImg})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        paddingLeft: mobile ? '15px' : '0', // 15px if mobile is true, 0 otherwise
        paddingRight: mobile ? '15px' : '0', // 15px if mobile is true, 0 otherwise
      }
    : {
        backgroundColor,
        paddingLeft: mobile ? '15px' : '0', // 15px if mobile is true, 0 otherwise
        paddingRight: mobile ? '15px' : '0', // 15px if mobile is true, 0 otherwise
      };
  
    const [isZoomedOut, setIsZoomedOut] = useState(false);
    const [isportrait,setIsportrait] = useState(false);
   // Trigger the zoom effect after the component mounts (page load)
   const isPlayMode = window.location.href.includes("m=play");
   useEffect(() => {
    const timer = setTimeout(() => {
      setIsZoomedOut(true);
    }, 100); // Small delay before zooming in (adjust as needed)

    return () => clearTimeout(timer); // Cleanup in case the component unmounts
  }, []); // Empty dependency array ensures it runs only once on page load
  // useEffect(() => {
  //   document.addEventListener('click', onCloseToggle);
  // }, [teamNames]);



    useEffect(() => {
      if (teamNames && teamNames.length > 0) {
        const teamScoreDataFromStorage = JSON.parse(localStorage.getItem('roundWinners')) || [];
        setTeamScoreData(teamScoreDataFromStorage); // Set teamScoreData in state
        calculateScoresAndPlayedRounds(teamScoreDataFromStorage);
      }
    }, [teamNames]);
    


    const calculateScoresAndPlayedRounds = (teamScoreData) => {
      let team1Wins = 0;
      let team2Wins = 0;
      let playedRounds = [];

      teamScoreData.forEach((round) => {
        if (round.team === teamNames[0]) {
          team1Wins++;
        } else if (round.team === teamNames[1]) {
          team2Wins++;
        }
        playedRounds.push(round.round); // Store the rounds that have been played
      });

      setTeamScores({ team1: team1Wins, team2: team2Wins });
      localStorage.setItem('score', JSON.stringify([team1Wins, team2Wins]));
      setPlayedRounds(playedRounds); // Store the played rounds
    };

    const hexToRgba = (hex, opacity) => {
      hex = hex.replace(/^#/, '');
      let r = parseInt(hex.substring(0, 2), 16);
      let g = parseInt(hex.substring(2, 4), 16);
      let b = parseInt(hex.substring(4, 6), 16);
      return `rgba(${r}, ${g}, ${b}, ${opacity})`;
    };
    const lightenColor = (hex, percent) => {
      hex = hex.replace(/^#/, '');
      let r = parseInt(hex.substring(0, 2), 16);
      let g = parseInt(hex.substring(2, 4), 16);
      let b = parseInt(hex.substring(4, 6), 16);
    
      // Calculate the adjustment based on percentage
      r = Math.min(255, Math.round(r + (255 - r) * percent));
      g = Math.min(255, Math.round(g + (255 - g) * percent));
      b = Math.min(255, Math.round(b + (255 - b) * percent));
    
      return `rgba(${r}, ${g}, ${b}, 1)`;
    };
    
    const backgroundColor1 = lightenColor(team1bgColor, 0.2); // Lighten by 80%
    const backgroundColor2 = lightenColor(team2bgColor, 0.2); // Lighten by 80%

    useEffect(() => {
      if (orientation === 'portrait') {
        // User is on a mobile device in portrait mode
        setIsportrait(true);
        console.log("Mobile portrait mode detected");
      } else {
        setIsportrait(false);
        console.log("Not mobile portrait mode");
      }
    }, [orientation]);
    
    const handleRoundClick = async (index) => {
      try {
          const db = firebase.database();
          const ref = db.ref(`AppleTV/${code}`);
          
          // Remove guessedWordbyparticipant from Firebase
          await ref.child("guessedWordbyparticipant").remove();
          console.log("guessedWordbyparticipant removed successfully.");
  
          // Set the command to 7320
          await ref.child("command").set("7320");
          console.log("Command set to 7320 successfully.");
  
          // Remove guessedWord from Firebase
          await ref.child("guessedWord").remove();
          console.log("Guessed words removed from Firebase.");
  
          // Get selected round and update the state
          const selectedRound = rounds[index];
          dispatch(setSelectedRound(selectedRound));
          localStorage.setItem('selectedRound', JSON.stringify(selectedRound));
  
          // Navigate to 'question' page
          onNavigate('question');
      } catch (error) {
          console.error("Error in handleRoundClick:", error);
      }
  };
  

    // const handleRoundClick = (index) => {

    //   const selectedRound = rounds[index];
    //   dispatch(setSelectedRound(selectedRound));
    //   localStorage.setItem('selectedRound', JSON.stringify(selectedRound));

  
    //   onNavigate('question');

    // };

    return (
      <>
        {isportrait ? (
          <>
        <div 
          style={{
            justifyContent: 'center',
            alignItems: 'center',
            height: '100vh',
            fontSize: '1.5rem',
            fontWeight:'bolder',
            backgroundColor:'#27738e',
            color: 'white',
            display:'flex',
            flexDirection:'column',
            padding: '1.5vh'
          }}
        >
          <span className='mt-2 mb-4 p-3 '> To view this game, you will need to place your device in landscape mode</span>

          <div style={{padding:'1.5vh'}}>
          <img src={landscapeIcon} alt="landscapeIcon" height={200} className="rotate-icon" />
          </div>
        </div>
        </>
      ):
       (
        <>
       <BasicHeader onNavigate={onNavigate}  style={{ backgroundColor:backgroundColor}} audio={audio} musicData={musicData} canPlay={canPlay} />
       <div className="main" style={backgroundStyle}>
          <Container fluid className="h-100 d-flex maincontainer flex-column align-items-center">
          <Row className="w-100 first">
      <Col xs={12} sm={4} md={4} lg={3} xl={2} className="d-flex justify-content-center align-items-center teamName"  style={{ opacity: isPlayMode ? 0 : 1 }}>
        <div className="Teamboxuiclassforsplash Teamboxuiclassforsplash-left" style={{ 
          backgroundColor: team1bgColor, 
          boxShadow: `0.5vw 6px 0px 0.3vw ${hexToRgba(team1bgColor, 0.8)}` 
        }}>
          <div className="teamnameclassforsplash" style={{ 
            backgroundColor: backgroundColor1,
            borderRadius: '5px' 
          }}>
{teamNames?.[0]?.length > 8 ? `${teamNames[0].slice(0, 6)}...` : (teamNames?.[0] || "")}
          </div>
          <div className="teamscorclassforsplash">
            <span id="teamscoreid1">{teamScores.team1}</span> {/* Dynamic score */}
          </div>
        </div>
      </Col>
      <Col xs={4} sm={4} md={4} lg={6} xl={8} className="thumbnail1 d-flex justify-content-center align-items-center">
      <img
        id="imgid"
        src={logo}
        alt="Game"
        className="image" // Apply the class that has the keyframe animation
      />
    </Col>
  
      <Col xs={4} sm={4} md={4} lg={3} xl={2} className={` d-flex justify-content-center align-items-center teamName`} style={{ opacity: isPlayMode ? 0 : 1 }}>
        <div className="Teamboxuiclassforsplash Teamboxuiclassforsplash-right " style={{ 
          backgroundColor: team2bgColor, 
          boxShadow: `0.5vw 6px 0px 0.3vw ${hexToRgba(team2bgColor, 0.8)}` 
        }}>
          <div className="teamnameclassforsplash" style={{ 
            backgroundColor: backgroundColor2,
            borderRadius: '5px' 
          }}>
 {teamNames?.[1]?.length > 8 ? `${teamNames[1].slice(0, 6)}...` : (teamNames?.[1] || "")}
          </div>
          <div className="teamscorclassforsplash">
            <span id="teamscoreid2">{teamScores.team2}</span> {/* Dynamic score */}
          </div>
        </div>
      </Col>
    </Row>

    <Row className="rowRound " >
  {
  rounds.map((round, index) => {
    // Find if the current round has been played and the corresponding team that won
    const playedRound = teamScoreData.find(r => r.round === index + 1); // Match round index+1 with teamScoreData round
    const isPlayed = !!playedRound; // Check if round is found in teamScoreData
    const winningTeam = playedRound ? playedRound.team : null; // Get the winning team if the round was played

    return (
      <Col
        key={index}
        xs={1.5} sm={1.5} md={1.5} lg={1.5} xl={1.5}
        className={`RoundBox d-flex  align-items-center justify-content-center ${isPlayed ? 'disabled' : ''}`}
        onClick={!isPlayed ? () => handleRoundClick(index) : null} // Disable round click if already played
        style={{ 
          cursor: isPlayed ? 'not-allowed' : 'pointer',
          backgroundColor: isPlayed 
            ? (winningTeam === 'Draw' 
                ? buttonColor // Use button color if it's a draw
                : (winningTeam === teamNames[0] ? team1bgColor : team2bgColor)) 
            : buttonColor, // Default button color for unplayed rounds
          opacity: isPlayed ? 0.6 : 1 // Set opacity based on isPlayed
        }}                   
      >
        <div
          className="TopDiv"
          style={{
            backgroundColor: isPlayed 
              ? (winningTeam === 'Draw' 
                  ? 'rgb(215 215 215)' // Use button color if it's a draw
                  : (winningTeam === teamNames[0] 
                      ? lightenColor(team1bgColor, 0.3) // Lighten team1bgColor by 20%
                      : lightenColor(team2bgColor, 0.3) // Lighten team2bgColor by 20%
                    )
                )
              : buttonColor, // Default button color for unplayed rounds
          }}
        ></div>
        {/* Positioned at the top */}
        <span className="RoundName" style={{color: fontColor}}>{`${localization?.rounds || "Round"} ${index + 1}`}</span>
      </Col>
    );
  })}
  {/* Add empty placeholders if needed to ensure spacing */}
  {rounds.length < 16 && Array.from({ length: 16 - rounds.length }).map((_, idx) => (
    <Col
      key={`empty-${idx}`}
      xs={1.5} sm={1.5} md={1.5} lg={1.5} xl={1.5}
      className="RoundBox emptyPlaceholder "
    />
  ))}
</Row>

          </Container>
        </div>
        </>
        )
  }
      </>
    );
  };

  export default HangManBasic;
